import { ETableStructureAlign, ETableStructureType, TTableStructure } from 'ui/EasTable/types';
import { TDailyExchangeRate } from 'redux/reducers/exchangeRates/types';

// The endpoint pages server side and exposes no sort field, so no column is sortable.
export const tableStructure: TTableStructure<keyof TDailyExchangeRate>[] = [
	{
		name: 'ID',
		selector: 'id',
		show: false,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.LEFT,
	},
	{
		// The only column the API itself can filter on — its value is sent as the `currency` request
		// field, the options come from the supported_currency enum.
		name: 'From Currency',
		selector: 'fromCurrency',
		show: true,
		sortable: false,
		filterable: false,
		separateFilter: true,
		separateFilterAutocomplete: true,
		colSpan: 1,
		type: ETableStructureType.CURRENCY,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'To Currency',
		selector: 'toCurrency',
		show: true,
		sortable: false,
		filterable: false,
		searchable: false,
		colSpan: 1,
		type: ETableStructureType.CURRENCY,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Daily Rate',
		selector: 'dailyRate',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.RIGHT,
	},
	{
		name: 'Date',
		selector: 'date',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.DATE,
		align: ETableStructureAlign.CENTER,
	},
];
